import { StarFill } from "react-bootstrap-icons";

export const PresentsHighPriorityStar = (): JSX.Element => {
    return <StarFill className="text-warning position-relative" style={{bottom: "2px"}}/>;
};

export const PresentsSelfClaimedText = (props: React.HTMLAttributes<HTMLSpanElement>): JSX.Element => {
    return <span className={"border-bottom border-warning " + props.className}>{props.children}</span>;
};